module.exports = __webpack_public_path__ + "images/constituting_ai.png?v=04cbf679c93b1a801e3600cac7b944a8";